<div
  class="p-grid p-align-stretch vertical-container p-p-5 p-mt-0 engine-container"
  *ngIf="layout$ | async as layout"
  >
  <div class="main-container">
    <div class="p-col-12">
      <h2 class="p-mb-1">{{ pipelineChartHeader$ | async }}</h2>
      <p class="p-mb-2">
        <span *ngIf="layout.loading">Loading...</span>
        <ng-container *ngIf="!layout.loading">
          Last updated
          <app-time-since [unixTime]="layout.lastReload"></app-time-since>
        </ng-container>
      </p>
      <div class="dropdowns">
        <p-dropdown
          [ngModel]="layout.groupLeadsBy"
          (ngModelChange)="setGroupLeadsBy($event)"
          appendTo="body"
          [options]="groupLeadsBy"
          >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-sort-amount-down-alt"></i>
              <span>
                Group Leads By: {{ layout.groupLeadsBy }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          [ngModel]="layout.metric"
          (ngModelChange)="setMetric($event)"
          appendTo="body"
          [options]="metrics"
          >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-chart-bar"></i>
              <span>
                Metric: {{ layout.metric }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          [ngModel]="layout.period"
          (ngModelChange)="setPeriod($event)"
          appendTo="body"
          [options]="periods"
          >
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-map-marker"></i>
              <span>
                Anchor Point: {{ layout.period }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
        <p-chip
        *ngFor="let chip of (filterChips$ | async)"
        [label]="chip.label"
        [removable]="true"
        (onRemove)="chip.onRemove()"
        ></p-chip>
      </div>
    </div>
    <div class="p-col-12">
      <app-pipeline></app-pipeline>
    </div>
    <div class="p-col-12">
      <app-engine-preview></app-engine-preview>
    </div>
  </div>
  <div class="p-col-3 right-column">
    <div class="inside-card p-my-2" *ngIf="false">
      GROWTH
    </div>
    <ng-container *ngIf="actionableItems$ | async as actionableItems">
      <div class="actionable-items" *ngIf="actionableItems.hasActionableItems">
        <h3>Actionable Items</h3>
        <div class="inside-card" *ngIf="actionableItems.openInvoices.show">
          <div class="content">
            <span class="title">Review Open Invoices</span>
            Ensure timely payments to maintain healhty cash flow.
          </div>
          <div class="p-d-flex p-jc-between p-ai-center p-mt-2">
            <p-button
              label="Review Invoices"
              size="small"
              (click)="actionableItems.openInvoices.review()"
              ></p-button>
            <div class="p-p-1 p-text-center">
              <small class="error-text" *ngIf="actionableItems.openInvoices.revenue"> <i class="pi pi-exclamation-triangle" style="font-size:0.75rem"></i> {{ actionableItems.openInvoices.revenue }} Unpaid Balances</small>
            </div>
          </div>
        </div>
        <div class="inside-card" *ngIf="actionableItems.openEstimates.show">
          <div class="content">
            <span class="title">Review Open Estimates</span>
            Review and approve pending estimates to move jobs forward and close deals.
          </div>
          <div class="p-d-flex p-jc-between p-ai-center p-mt-2">
            <p-button
              label="Review Estimates"
              size="small"
              (click)="actionableItems.openEstimates.review()"
              ></p-button>
            <div class="p-p-1 p-text-center">
              <small class="success-text" *ngIf="actionableItems.openEstimates.revenue">+ {{ actionableItems.openEstimates.revenue }} Potential revenue</small>
            </div>
          </div>
        </div>
        <div class="inside-card" *ngIf="actionableItems.openLeads.show">
          <div class="content">
            <span class="title">Review Open Leads</span>
            Follow up on potential customers to increase bookings and grow revenue.
          </div>
          <div class="p-d-flex p-jc-between p-ai-center p-mt-2">
            <p-button
              label="Review Leads"
              size="small"
              (click)="actionableItems.openLeads.review()"
              ></p-button>
            <div class="p-p-1 p-text-center">
              <small class="success-text" *ngIf="actionableItems.openLeads.revenue">+ {{ actionableItems.openLeads.revenue }} Potential revenue</small>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
